/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

import {
  Card,
  CardContent,
  createStyles,
  Grid,
  Typography,
  withStyles,
  WithStyles,
} from '@nelnet/unifi-components-react';

import Link from './Link';
import { IPageDataItems } from '../utils/declarations';
import { card } from '../styles/cards';

const styles = () =>
  createStyles({
    card: { ...card },
  });

interface IPlatformCardsProps extends WithStyles<typeof styles> {
  cardItems: IPageDataItems[];
}

/*
The cards present on the primary platform page (React, Web) that lists the linked names of components in that category.
*/
const PlatformCards: React.FunctionComponent<IPlatformCardsProps> = ({ classes, cardItems }) => {
  return (
    <Grid container constrained spacing={3} margin={{ top: 4 }}>
      {cardItems.map((component) => {
        const { title, slug, children }: IPageDataItems = component;

        return (
          <Grid key={slug} item container sm={6} md={4}>
            <Card className={classes.card}>
              <CardContent>
                <Typography variant="h3" color="textPrimary" gutterBottom>
                  {title}
                </Typography>
                <Typography>
                  {children
                    ? children
                        .map((child) => {
                          const childTitle = child.title;
                          const childSlug = child.slug;

                          return (
                            <Link key={childSlug} href={childSlug} underline="always">
                              {childTitle}
                            </Link>
                          );
                        })
                        .reduce(((prev: JSX.Element, curr: JSX.Element): any => [
                          prev,
                          ', ',
                          curr,
                        ]) as any)
                    : null}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default withStyles(styles)(PlatformCards);
